import React, { useState, useEffect } from "react";
import { Container, Modal, ModalBody } from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Import images
import logolight from "../../assets/images/hrplus.png";
import logodark from "../../assets/images/hrplus.png"; // Agar boshqa bo‘lsa, shuni qo‘ying

// Components
import LightDark from "../../Layouts/Components/LightDark";
import LanguageDropdown from "../../Layouts/Components/LanguageDropdown";
import Register from "../../pages/Auth/Register";
import SMSCode from "../../pages/Auth/SmsCode";

// Redux actions
import { changeLayoutMode } from "../../store/layout/query";
import {
    toggleShowDemoRequest,
    setIsModalOpen
} from "../../store/requestDemo/slice";

const Navbar = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [isOpenMenu, setisOpenMenu] = useState(false);
    const [navClass, setnavClass] = useState("");
    const [isSMSCode, setIsCodeSMS] = useState(0);
    const [userID, setUserID] = useState(null);

    const toggle = () => setisOpenMenu(!isOpenMenu);

    const scrollNavigation = () => {
        const scrollTop = document.documentElement.scrollTop;
        setnavClass(scrollTop > 50 ? "is-sticky" : "");
    };

    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation);
        return () => window.removeEventListener("scroll", scrollNavigation);
    }, []);

    const layoutModeType = useSelector(state => state.Layout.layoutModeType);
    const isModalOpen = useSelector(state => state.requestDemo.isModalOpen);

    useEffect(() => {
        if (layoutModeType) {
            dispatch(changeLayoutMode(layoutModeType));
        }
    }, [layoutModeType, dispatch]);

    const onChangeLayoutMode = (value) => {
        dispatch(changeLayoutMode(value));
    };

    const goBack = (e) => {
        e.preventDefault();
        window.history.back();
    };

    const toggleModal = () => {
        dispatch(setIsModalOpen(!isModalOpen));
    };

    const changeSMSCode = (id) => {
        setIsCodeSMS(id);
    };

    const handlerDemoRequest = () => {
        changeSMSCode(0);
        dispatch(toggleShowDemoRequest(true));
        dispatch(setIsModalOpen(true));
    };

    return (
        <React.Fragment>
            <nav className={`navbar navbar-expand-lg navbar-landing fixed-top ${navClass}`} id="navbar">
                <Container>
                    <Link className="navbar-brand" to="/">
                        <img src={logodark} className="card-logo card-logo-dark" alt="logo dark" height="45" />
                        <img src={logolight} className="card-logo card-logo-light" alt="logo light" height="45" />
                    </Link>
                    <div>
                        <Link
                            to="#"
                            className="btn btn-link link-dark d-flex align-items-center gap-1"
                            onClick={goBack}
                        >
                            <i className="ri-arrow-left-s-line fs-20"></i>
                            <span className="fs-17">{t("t-back")}</span>
                        </Link>
                    </div>
                    <div className="d-inline-flex gap-2 align-items-center">
                        <LightDark
                            layoutMode={layoutModeType}
                            onChangeLayoutMode={onChangeLayoutMode}
                        />
                        <LanguageDropdown />
                        <div className="ms-lg-3 me-lg-n3 text-nowrap">
                            <button className="btn btn-success" onClick={handlerDemoRequest}>
                                {t("t-demo-request")}
                            </button>
                            <Link className="btn btn-primary ms-2" to="https://online.hrplus.uz/login" target="_blank">
                                {t("t-login")}
                            </Link>
                        </div>
                    </div>
                </Container>
            </nav>

            <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
                <div className="modal-header p-3 bg-primary">
                    <h5 className="text-white mb-0">{t("t-use-demo")}</h5>
                    <span className="cursor-pointer" onClick={toggleModal}>
                        <i className="ri-close-line fs-22 text-white"></i>
                    </span>
                </div>
                <ModalBody>
                    {isSMSCode === 0 ? (
                        <Register toggle={changeSMSCode} changeUSerID={setUserID} toggleModal={toggleModal} />
                    ) : isSMSCode === 1 ? (
                        <SMSCode user_id={userID} toggle={changeSMSCode} />
                    ) : (
                        <div className="text-center mt-3">
                            <h4 className="text-success">{t("t-request-accepted")}</h4>
                            <p className="fs-14">{t("t-connect")}</p>
                            <div className="text-end mt-5">
                                <button className="btn btn-light" onClick={toggleModal}>
                                    {t("t-close")}
                                </button>
                            </div>
                        </div>
                    )}
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default Navbar;
